<template>
  <div v-if="leads" class="detail">
    <div>
      <div class="nav">
        <div class="nav-l">
          <div class="nav-l-tab" :class="{ isActive: activeTab === item.type }" v-for="item in tabs" :key="item.id"
            @click="changeTab(item.type)">
            <template v-if="item.show">
              {{ item.name }}
            </template>
          </div>
        </div>
        <div class="nav-r">
          <el-button v-if="isBack" @click="goBack">返回</el-button>
        </div>
      </div>
      <div class="tabs">
        <template v-if="activeTab === 'basic'">
          <div class="header">
            <div class="header-left">
              <div class="heard">
                <span class="heard-label">负责人：</span>
                <span class="heard-name">
                  {{ leads.owner_name }}
                </span>
              </div>
              <div v-if="leads.follow_time === leads.createtime">
                最近跟进时间： <span class="red">暂无</span>
              </div>
              <div v-else>
                预计成交时间：
                <span class="red"> {{ leads.deal_date }}</span>
              </div>
            </div>
            
          </div>
          <div class="tabs-container">
            <el-form   v-if="leads" ref="form" :model="leads" label-width="120px" label-position="left" >
              <div class="head-title">商机信息</div>
              <div class="info-item">
                <el-form-item prop="customer_name" :rules="{
                  required: true,
                  message: '请选择客户',
                  trigger: 'blur',
                }" label="客户名称" @click.native="client">
                  <div  class="ipt" :title="leads.customer_name" v-if="editState === 'readonly'">{{
                    leads.customer_name
                  }}</div>
                  <el-input v-else v-model="leads.customer_name" style="width: 220px" clearable></el-input>
                </el-form-item>
                <el-form-item prop="name" :rules="{
                  required: true,
                  message: '请输入商机名称',
                  trigger: 'blur',
                }" label="商机名称">
                  <div :title="leads.name " class="ipt"  v-if="editState === 'readonly'">{{ leads.name }}</div>
                  <el-input v-else v-model="leads.name" style="width: 220px" clearable></el-input>
                </el-form-item>
                <el-form-item prop="remark_mobiles" :rules="{
                  required: true,
                  message: '请输入手机号',
                  trigger: 'blur',
                }" label="备注电话">
                  <div :title="leads.remark_mobiles" class="ipt" v-if="editState === 'readonly'">{{
                    leads.remark_mobiles
                  }}</div>
                  <el-input v-else v-model="leads.remark_mobiles" style="width: 220px" clearable></el-input>
                </el-form-item>
                <el-form-item label="商机金额">
                  <span v-if="editState === 'readonly'">{{ leads.money }}</span>
                  <el-input v-else v-model="leads.money"
                  type="number"
                  min="0"
                  @blur="getValueData"
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
                  style="width: 220px" clearable></el-input>
                </el-form-item>
                <el-form-item label="预计成交时间">
                  <span v-if="editState === 'readonly'">{{
                    leads.deal_date
                  }}</span>
                  <!-- <el-input  prefix-icon="el-icon-date"  :value="leads.deal_date" style="width: 220px" clearable></el-input> -->
                  <el-date-picker 
                  v-else
                  v-model="leads.deal_date" 
                  type="date" 
                  placeholder="选择日期" 
                  format="yyyy 年 MM 月 dd 日" 
                  value-format="yyyy-MM-dd"
                  @change="chengjiaodata"> 
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                  <div :title="leads.remark"  class="ipt" v-if="editState === 'readonly'">{{
                    leads.remark
                  }}</div>
                  <el-input v-else v-model="leads.remark" style="width: 220px" clearable></el-input>
                </el-form-item>
              </div>
              <el-divider v-if="editState === 'readonly'"></el-divider>
              <div v-if="editState === 'readonly'" class="head-title">
                系统信息
              </div>
              <div v-if="editState === 'readonly'" class="info-item">
                <el-form-item label="负责人">
                  <span>
                    {{ leads.owner_name }}
                  </span>
                </el-form-item>
                <el-form-item label="创建时间">
                  <span>{{ leads.createtime | formatDate }}</span>
                </el-form-item>
                <el-form-item label="更新于">
                  <span>{{ leads.updatetime | formatDate }}</span>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <el-divider></el-divider>
          <div class="detail-title">自定义字段信息</div>
          <form-create :id="lockSave ? 'formCreata' : '' "   v-model="yulanform" :rule="formrule" :class="selfLock ? 'selfLock' : ''" :option="option"
            @on-submit="onSubmit1" style="width: 80%;margin-top: 20px;"></form-create>
        </template>
        <logger  v-if="activeTab === 'log'" :data="leads" types="business"></logger>
      </div>
    </div>
    <div class="detail-bottom" v-if="activeTab === 'basic'">
      <div class="header-right">
              <div class="head-menu">
                <div class="head-menu-left">
                  <el-button type="primary" @click="onEdit">
                    <i class="iconfont iconbanji"></i>
                    编辑
                  </el-button>
                  <el-button type="primary" :disabled="lockSave" @click="onSave">
                    <i class="iconfont iconbaocun"></i>
                    保存
                  </el-button>
                </div>
                <div class="head-menu-right"></div>
              </div>
            </div>
    </div>
    <el-dialog title="选择客户名称" :modal-append-to-body="false" :visible.sync="onSubmit" width="30%">
      <el-form ref="form" label-width="80px">
        <div>123123</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="(onSubmit = false), numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <mail-list ref="drawer" :module="module" @handleSelect="handleSelect"></mail-list>
  </div>
</template>
<script>
import qs from "qs";
import mailList from '@/components/drawer/mailList'
import logger from "@/components/Logger";
import { businessListOne } from "@/api/business";
import { contactsList, actionLogList } from "@/api/common";
import { regionData, TextToCode } from "element-china-area-data";
export default {
  name: "businessDetail",
  inject: ["reload"],
  components: {
    mailList,
    logger,
  },
  data() {
    return {
      activeTab: "basic",
      editArea: true,
      module: "",
      search: "",
      onSubmit: false,
      leads: {},
      sex: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      source: null,
      editState: "readonly",
      area: regionData,
      record: [],
      dialogFormVisible: false,
      recordData: {
        id: 0,
        contacts_id: "",
        contacts_name: "",
        business_id: "",
        business_name: "",
        content: "",
        next_time: "",
      },
      totalRecord: 0,
      listQueryRecord: {
        page: 1,
        limit: 20,
      },
      noRecord: false,
      pickerOptionsN: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      log: [],
      totalLog: 0,
      listQueryLog: {
        page: 1,
        limit: 20,
      },
      noLog: false,
      contactTable: [],
      noContact: false,
      totalContact: 0,
      listQueryContact: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      mailListShow: false,
      crm: {},
      options: [],
      value: "",
      id: "",
      if_leader: false, //是否领导查看
      lockSave: true,
      tabs: [
        {
          id: 1,
          name: "基本信息",
          type: "basic",
          show: true,
        },
        {
          id: 3,
          name: "操作日志",
          type: "log",
          show: true,
        },
      ],
      yulanform: "",
      formrule: [],
      option: {
        submitBtn: {
          show: false,
        },
      },
      fie: [],
      custom_field: {},
      selfLock: true,
      numMoney:0//金额为数值定义的参数
    };
  },
  computed: {
    isBack() {
      return this.$store.state.user.userInfo.type == 1;
    }
  },
  async mounted() {
    window.sessionStorage.setItem('sj_if_leader',this.$route.params.if_leader);
    if (!this.$store.state.app.business) {
      this.$router.go(-1);
      return;
    }
    await this.getLeads();
    await this.customerList();
    if (this.leads.owner !== this.$store.state.user.token.userid) {
      this.if_leader = true;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    customerList() {
      this.axios
        .post(
          "/crm/Customer/customerList",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.app.business.owner,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.options = res.data;
          this.id = res.data.id;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    client() {
      if(this.lockSave == false){
        this.module = "customerList";
        this.$refs.drawer.open();
      }
      
    },
    async getLeads() {
      const leads = await businessListOne({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.app.business.owner,
        id: this.$route.params.id,
      });
      if (leads.data.address) {
        const value = leads.data.address.split(",");
        const provinceCode = value[0];
        const cityCode = value[1];
        const areaCode = value[2];
        const address = TextToCode[provinceCode][cityCode][areaCode].code;
        leads.data.address = address;
      }

      let arr = []
      this.formrule = []
      this.custom_field = leads.data.self_content;
      for (let i in this.custom_field) {
        arr.push(this.custom_field[i])
      }
      arr.forEach(item => {
        if (!item.if_show) {
          item.display = item.if_show
        }
      })
      this.formrule = arr;

      this.leads = leads.data;
      this.id = leads.data.id;
    },
    async getLog() {
      const res = await actionLogList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.app.business.owner,
        types: "leads",
        types_id: this.leads.id,
        page: this.listQueryLog.page,
      });
      if (res.code == 1) {
        this.totalLog = res.count;
        this.log = this.log.concat(res.data);
      } else if (res.code == 0) {
        this.noLog = true;
      }
    },
    async getContactsList({ search = "" } = {}) {
      const res = await contactsList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.app.business.owner,
        page: this.listQueryContact.page,
        name: search,
      });
      if (res.code == 1) {
        this.totalContact = res.count;
        this.contactTable = res.data;
      } else if (res.code == 0) {
        this.noContact = true;
      }
    },
    handleSelect(person) {
      this.id = person.id;
      this.leads.customer_name = person.name;
      console.log(person);
    },
    handleSelectionChange(val) {
      // 选择相关联系人
      this.multipleSelection = val;
    },
    changeTab(type) {
      this.activeTab = type;
    },
    onSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.editState = "readonly";
          if(this.leads.deal_date == null){
            this.leads.deal_date = '暂无'
          }
          this.onSaveBusiness();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSaveBusiness() {
      //日期转时间戳
      var time=new Date(this.leads.deal_date)
      var timedata = time.getTime()/1000

      let selfSub = {}
      for (let i in this.custom_field) {
        this.fie.push(i)
      }
      for (let i = 0; i < this.fie.length; i++) {
        for (let j = 0; j < this.formrule.length; j++) {
          if (this.formrule[j].field == this.fie[i]) {
            this.$set(selfSub, this.fie[i], this.formrule[j])
          }
        }
      }
      this.axios
        .post(
          "/crm/Business/editBusiness",
          qs.stringify({
            id: this.leads.id,
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.app.business.owner,
            customer_id: this.id,
            name: this.leads.name,
            money: this.leads.money,
            deal_date: timedata,
            owner: this.owner,
            remark_mobiles: this.leads.remark_mobiles,
            remark:this.leads.remark,
            self_content: JSON.stringify(selfSub)
            
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.code == 1) {
            this.lockSave = true;
            this.$message({
              type: "success",
              message: res.msg,
            });
          }
          if(res.code == 0){
            this.lockSave=false
            this.editState = 'edit'
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    showRecord() {
      this.dialogFormVisible = true;
      this.getContactsList(this.contactPage);
    },
    editRecord(data) {
      let date = new Date(data.next_time * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      let H = date.getHours();
      let m = date.getMinutes();
      this.getContactsList(this.contactPage);
      this.recordData = {
        id: data.id,
        contacts_id: data.contacts_id,
        business_id: data.business_id,
        content: data.content,
        next_time: new Date(Y, M, D, H, m),
      };
      this.dialogFormVisible = true;
    },
    onContact() {
      // 跟进记录打开联系人选择
      this.module = "recordContact";
      this.$refs.drawer.open();
    },
    onBusiness() {
      // 跟进记录打开商机选择
      this.module = "businessList";
      this.$refs.drawer.open();
    },
    onEdit() {
      this.editState = "edit";
      this.lockSave = false;
      this.selfLock = false
      if(this.leads.deal_date == '暂无'){
        this.leads.deal_date = null
      }
    },
    handleEdit(id) {
      // 编辑相关联系人
      this.$store.commit("app/CONTACT_STATE", "edit");
      this.$router.push({
        name: "contactDetail",
        query: {
          id,
        },
      });
    },
    handleRead(id) {
      // 查看相关联系人
      this.$store.commit("app/CONTACT_STATE", "readonly");
      this.$router.push({
        name: "contactDetail",
        query: {
          id,
        },
      });
    },
    onSubmit1(formData) {
      alert(JSON.stringify(formData));
    },
    /*只允许金额为数字*/ 
    getValueData() {
      if (this.numMoney) {
        let a = this.numMoney.substring(0, 1);
        let b = this.numMoney.substring(1, 2);
        if (a == '0' && b != '.') {
          this.numMoney = this.numMoney.slice(1);
        }
      }
    },
    
    chengjiaodata(date){
      
      this.leads.deal_date = date
      
      
    }
  },
};
</script>
<style lang="scss" scoped>
.selfLock{
  pointer-events: none;
}
@import "~@/styles/detail.scss";

::v-deep .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-form-item{
  display: inline-table !important;
}

.ipt {
  text-overflow: ellipsis;
  word-break: break-all;
  padding-left: 0px;
}
.head-title{
  
  font-size:21px;
  color:#333333;
  margin-top:30px;
  padding:0 20px ;
  padding:30px  20px  20px;
  
}
.info-item{
  margin-top: -17px;
  padding:0 20px;
}
.el-form{
  margin: 0 ;
}

</style>